module.exports = __webpack_public_path__ + "static/media/ec_white_negative_color.d58a2de0.png";